import React from "react";

import QuestionImagePreview from "./QuestionImagePreview";
import QuestionImageUpload from "./QuestionImageUpload";
import QuestionImageActions from "./QuestionImageActions";

const QuestionImageItem = ({ question }) => {
  return (
    <div className="mb-6 rounded-xl border border-gray-200 bg-white shadow-sm">
      <div className="p-6">
        <div className="flex flex-col gap-4 lg:flex-row lg:justify-between">
          <div className="flex-1">
            <p className="text-sm font-medium text-gray-500">
              Question {question.order || ""}
            </p>

            <p className="mt-2 text-base font-semibold text-gray-900">
              {question.questionText}
            </p>

            {question.options?.length > 0 && (
              <div className="mt-4 space-y-2">
                {question.options.map((option) => (
                  <p
                    key={option.key}
                    className="text-sm text-gray-700"
                  >
                    <span className="font-medium">{option.key}.</span>{" "}
                    {option.text}
                  </p>
                ))}
              </div>
            )}
          </div>
        </div>

        <hr className="my-6 border-gray-200" />

        <div>
          <QuestionImagePreview imageUrl={question.imageUrl} />
        </div>

        <div className="mt-6 flex flex-wrap items-center gap-3">
          {question.imageUrl ? (
            <QuestionImageActions questionId={question._id} />
          ) : (
            <QuestionImageUpload questionId={question._id} />
          )}
        </div>
      </div>
    </div>
  );
};

export default QuestionImageItem;